"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeAvailableTimesMapper = void 0;
var RangeAvailableTimesMapper = /** @class */ (function () {
    function RangeAvailableTimesMapper(data) {
        this.localData = data;
    }
    RangeAvailableTimesMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return RangeAvailableTimesMapper;
}());
exports.RangeAvailableTimesMapper = RangeAvailableTimesMapper;
//# sourceMappingURL=RangeAvailableTimesMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/RangeAvailableTimesMapper.js
// module id = 2085
// module chunks = 8